import { Component, OnInit } from '@angular/core';
import { ViewEditableComponentAbstract } from '@shared/types/common.types';
import { BehaviorSubject, Observable } from 'rxjs';

export enum ViewEditMode {
  'view',
  'edit',
}

class Parent {}

@Component({
  selector: 'app-view-edit-switch',
  templateUrl: './view-edit-switch.component.html',
  styleUrls: ['./view-edit-switch.component.scss'],
})
export class ViewEditSwitchComponent implements OnInit {
  mode$: Observable<ViewEditMode>;
  viewEditMode = ViewEditMode;

  constructor(private parent: ViewEditableComponentAbstract) {}

  ngOnInit(): void {
    this.mode$ = this.parent.mode$;
  }
}
